// Core React Imports
import React, { useState } from "react";

// Local Imports
import { usePageModelInfo } from "./usePageModelInfo";
import ConstantsImages from "../../constants/ConstantsImages";
import ConstantsTexts from "../../constants/ConstantsTexts";
import ConstantsParams from "../../constants/ConstantsParams";
import { DivColumn, DivRow, ParagraphText, WidgetMarginHeight } from "../../styles/SharedStyles";
import WidgetInput from "../../widgets/inputs/widget-input/WidgetInput";
import WidgetInputSecond from "../../widgets/inputs/widget-input-second/WidgetInputSecond";
import WidgetInputsFromTo from "../../widgets/inputs/widget-inputs-from-to/WidgetInputsFromTo";
import WidgetTextViewData from "../../widgets/texts/WidgetTextViewData";
import WidgetAlertDialogEdit from "../../widgets/alert-dialogs/widget-alert-dialog-edit/WidgetAlertDialogEdit";
import WidgetAlertDialogFreezeVersion from "../../widgets/alert-dialogs/widget-alert-dialog-freeze-version/WidgetAlertDialogFreezeVersion";
import WidgetAlertDialogFreezeSuccess from "../../widgets/alert-dialogs/widget-alert-dialog-freeze-success/WidgetAlertDialogFreezeSuccess";
import WidgetAlertDialogSave from "../../widgets/alert-dialogs/widget-alert-dialog-save/WidgetAlertDialogSave";
import WidgetAlertDialogUpdateModelFields from "../../widgets/alert-dialogs/widget-alert-dialog-update-model-fields/WidgetAlertDialogUpdateModelFields";
import WidgetAlertDialogFrozenTerminalBlocked from "../../widgets/alert-dialogs/widget-alert-dialog-frozen-terminal-blocked/WidgetAlertDialogFrozenTerminalBlocked";
import WidgetProgressPercent from "../../widgets/progresses/WidgetProgressPercent";
import WidgetInputPercent from "../../widgets/inputs/widget-input-percent/WidgetInputPercent";
import WidgetUpdatesListGeneral from "../../widgets/shared_widgets/widget-updates-list-general/WidgetUpdatesListGeneral";
import WidgetModelVersionDropdown from "../../widgets/dropdowns/widget-model-version-dropdown/WidgetModelVersionDropdown";
import WidgetGaugeUI from "../../widgets/shared_widgets/widget-gauge-ui/WidgetGaugeUI";
import UtilsUnit from "../../utils/UtilsUnit";
import WidgetDashboardIcon from "../../widgets/shared_widgets/widget-dashboard-icon/WidgetDashboardIcon";
import WidgetSmallTransportationTitle from "../../widgets/shared_widgets/widget-small-transportation-title/WidgetSmallTransportationTitle";
import WidgetSearchFrame from "../../widgets/shared_widgets/widget-search-frame/WidgetSearchFrame";
import WidgetChangelogFrame from "../../widgets/shared_widgets/widget-changelog-frame/WidgetChangelogFrame";
import WidgetIconFive from "../../widgets/icons/widget-icon-five/WidgetIconFive";
import WidgetCustomFooterItemFirst from "../../widgets/shared_widgets/widget-footers/widget-custom-footer-item-first/WidgetCustomFooterItemFirst";
import WidgetCustomFooterItemSecond from "../../widgets/shared_widgets/widget-footers/widget-custom-footer-item-second/WidgetCustomFooterItemSecond";
import WidgetCreateTerminalIcon from "../../widgets/shared_widgets/widget-create-terminal-icon/WidgetCreateTerminalIcon";
import WidgetUsersIcon from "../../widgets/shared_widgets/widget-users-icon/WidgetUsersIcon";
import WidgetChangeRequestsIcon from "../../widgets/shared_widgets/widget-change-requests-icon/WidgetChangeRequestsIcon";

// CSS/Stylesheets
import "./PageModelInfo.css";

function PageModelInfo() {
  const [isFrozenTerminalBlockedOpen, setIsFrozenTerminalBlockedOpen] = useState(false);

  const {
    dataIsReceived,
    getMainMeasurePercent,
    inputValueUrgencyPercent,
    handleChangeUrgencyPercent,
    inputValueImportanceServicePercent,
    handleChangeImportanceServicePercent,
    inputValuePotentialPercent,
    handleChangePotentialPercent,
    inputValueReducingOperationalGapPercent,
    handleChangeReducingOperationalGapPercent,
    inputValueUrgencyOne,
    handleChangeUrgencyOne,
    inputValueImportanceServiceOneFrom,
    inputValueImportanceServiceOneTo,
    handleChangeImportanceServiceOneFrom,
    handleChangeImportanceServiceOneTo,
    inputValuePotentialOneFrom,
    inputValuePotentialOneTo,
    handleChangePotentialOneFrom,
    handleChangePotentialOneTo,
    inputValueReducingOperationalGapOneFrom,
    inputValueReducingOperationalGapOneTo,
    handleChangeReducingOperationalGapOneFrom,
    handleChangeReducingOperationalGapOneTo,
    inputValueUrgencyTwo,
    handleChangeUrgencyTwo,
    inputValueImportanceServiceTwoFrom,
    inputValueImportanceServiceTwoTo,
    handleChangeImportanceServiceTwoFrom,
    handleChangeImportanceServiceTwoTo,
    inputValuePotentialTwoFrom,
    inputValuePotentialTwoTo,
    handleChangePotentialTwoFrom,
    handleChangePotentialTwoTo,
    inputValueReducingOperationalGapTwoFrom,
    inputValueReducingOperationalGapTwoTo,
    handleChangeReducingOperationalGapTwoFrom,
    handleChangeReducingOperationalGapTwoTo,
    inputValueUrgencyThree,
    handleChangeUrgencyThree,
    inputValueImportanceServiceThreeFrom,
    inputValueImportanceServiceThreeTo,
    handleChangeImportanceServiceThreeFrom,
    handleChangeImportanceServiceThreeTo,
    inputValuePotentialThreeFrom,
    inputValuePotentialThreeTo,
    handleChangePotentialThreeFrom,
    handleChangePotentialThreeTo,
    inputValueReducingOperationalGapThreeFrom,
    inputValueReducingOperationalGapThreeTo,
    handleChangeReducingOperationalGapThreeFrom,
    handleChangeReducingOperationalGapThreeTo,
    inputValueUrgencyFour,
    handleChangeUrgencyFour,
    inputValueImportanceServiceFourFrom,
    inputValueImportanceServiceFourTo,
    handleChangeImportanceServiceFourFrom,
    handleChangeImportanceServiceFourTo,
    inputValuePotentialFourFrom,
    inputValuePotentialFourTo,
    handleChangePotentialFourFrom,
    handleChangePotentialFourTo,
    inputValueReducingOperationalGapFourFrom,
    inputValueReducingOperationalGapFourTo,
    handleChangeReducingOperationalGapFourFrom,
    handleChangeReducingOperationalGapFourTo,
    inputValueUrgencyFive,
    handleChangeUrgencyFive,
    inputValueImportanceServiceFiveFrom,
    inputValueImportanceServiceFiveTo,
    handleChangeImportanceServiceFiveFrom,
    handleChangeImportanceServiceFiveTo,
    inputValuePotentialFiveFrom,
    inputValuePotentialFiveTo,
    handleChangePotentialFiveFrom,
    handleChangePotentialFiveTo,
    inputValueReducingOperationalGapFiveFrom,
    inputValueReducingOperationalGapFiveTo,
    handleChangeReducingOperationalGapFiveFrom,
    handleChangeReducingOperationalGapFiveTo,
    handleCancelModelChanges,
    inputValueLifeTime,
    handleChangeLifeTime,
    inputValueBusinessDays,
    handleChangeBusinessDays,
    inputValuePositionLocalAuthorityPercent,
    handleChangePositionLocalAuthorityPercent,
    inputValueMetropolitanRingOne,
    handleChangeMetropolitanRingOne,
    inputValueMetropolitanRingTwo,
    handleChangeMetropolitanRingTwo,
    inputValueMetropolitanRingThree,
    handleChangeMetropolitanRingThree,
    inputValueMetropolitanRingFour,
    handleChangeMetropolitanRingFour,
    inputValueCostPerAcre,
    handleChangeCostPerAcre,
    workMonthsText,
    inputValueMonthsOfWorkOne,
    handleChangeMonthsOfWorkOne,
    inputValueCostOfBuildingsOne,
    handleChangeCostOfBuildingsOne,
    inputValueCostOfTrafficOne,
    handleChangeCostOfTrafficOne,
    getTotalPriceForTrafficArrangementsPerTerminalTypeNIS,
    inputValueMonthsOfWorkTwo,
    handleChangeMonthsOfWorkTwo,
    inputValueCostOfBuildingsTwo,
    handleChangeCostOfBuildingsTwo,
    inputValueCostOfTrafficTwo,
    handleChangeCostOfTrafficTwo,
    inputValueMonthsOfWorkThree,
    handleChangeMonthsOfWorkThree,
    inputValueCostOfBuildingsThree,
    handleChangeCostOfBuildingsThree,
    inputValueCostOfTrafficThree,
    handleChangeCostOfTrafficThree,
    inputValueMonthsOfWorkFour,
    handleChangeMonthsOfWorkFour,
    inputValueCostOfBuildingsFour,
    handleChangeCostOfBuildingsFour,
    inputValueCostOfTrafficFour,
    handleChangeCostOfTrafficFour,
    inputValueMonthsOfWorkFive,
    handleChangeMonthsOfWorkFive,
    inputValueCostOfBuildingsFive,
    handleChangeCostOfBuildingsFive,
    inputValueCostOfTrafficFive,
    handleChangeCostOfTrafficFive,
    inputValueCostPerPassengerPercent,
    handleChangeCostPerPassengerPercent,
    inputValueCostPerTripPercent,
    handleChangeCostPerTripPercent,
    inputValueCostPerPassengerOneFrom,
    inputValueCostPerPassengerOneTo,
    handleChangeCostPerPassengerOneFrom,
    handleChangeCostPerPassengerOneTo,
    inputValueCostPerTripOneFrom,
    inputValueCostPerTripOneTo,
    handleChangeCostPerTripOneFrom,
    handleChangeCostPerTripOneTo,
    inputValueCostPerPassengerTwoFrom,
    inputValueCostPerPassengerTwoTo,
    handleChangeCostPerPassengerTwoFrom,
    handleChangeCostPerPassengerTwoTo,
    inputValueCostPerTripTwoFrom,
    inputValueCostPerTripTwoTo,
    handleChangeCostPerTripTwoFrom,
    handleChangeCostPerTripTwoTo,
    inputValueCostPerPassengerThreeFrom,
    inputValueCostPerPassengerThreeTo,
    handleChangeCostPerPassengerThreeFrom,
    handleChangeCostPerPassengerThreeTo,
    inputValueCostPerTripThreeFrom,
    inputValueCostPerTripThreeTo,
    handleChangeCostPerTripThreeFrom,
    handleChangeCostPerTripThreeTo,
    inputValueCostPerPassengerFourFrom,
    inputValueCostPerPassengerFourTo,
    handleChangeCostPerPassengerFourFrom,
    handleChangeCostPerPassengerFourTo,
    inputValueCostPerTripFourFrom,
    inputValueCostPerTripFourTo,
    handleChangeCostPerTripFourFrom,
    handleChangeCostPerTripFourTo,
    inputValueCostPerPassengerFiveFrom,
    inputValueCostPerPassengerFiveTo,
    handleChangeCostPerPassengerFiveFrom,
    handleChangeCostPerPassengerFiveTo,
    inputValueCostPerTripFiveFrom,
    inputValueCostPerTripFiveTo,
    handleChangeCostPerTripFiveFrom,
    handleChangeCostPerTripFiveTo,
    buildingCostText,
    monthlyTrafficArrangementCostText,
    totalTrafficArrangementCostText,
    modelChangesLog,
    isDialogEditOpen,
    closeEditAlertDialog,
    isDialogSaveOpen,
    closeSaveAlertDialog,
    isDialogUpdateModelFieldsOpen,
    setDialogUpdateModelFieldsOpen,
    getDialogEditCancelText,
    getDialogSaveMessageText,
    getDialogEditMessageText,
    getDialogEditApproveText,
    showUpdatesList,
    handleShowUpdatesListClick,
    handleSearchTerminalIconClick,
    uniqueDistricts,
    handleSelectDropdownDistrict,
    selectedDistrict,
    uniquePlanningSpace,
    handleSelectDropdownPlanningSpace,
    selectedPlanningSpace,
    uniqueMunicipalities,
    handleSelectDropdownMunicipality,
    selectedMunicipality,
    uniqueTerminals,
    handleSelectDropdownTerminal,
    selectedTerminal,
    showSearchTerminal,
    selectedModelVersion,
    handleSelectModelVersion,
    modelVersions,
    isModelVersionGreaterThanZeroOrCreatingNew,
    isCreatingNewModelVersion,
    handleCreateModelVersion,
    userData,
    handleFormSubmit,
    handleBaseModelChange,
    handleBaseModelClose,
    isBaseModelSelected,
    dropdownType,
    shouldShowModelVersionCustomFooterItemSecond,
    handleDeleteModelVersionClick,
    handleFreezeModelVersionClick,
    shouldShowFreezeModelVersionButton,
    shouldShowCreateModelVersionFooterItem,
    lastActionRef,
    modelVersionToFreezeRef,
    handleCloseUpdateModelFieldsDialog,
  } = usePageModelInfo();

  const fieldsReadOnly = isModelVersionGreaterThanZeroOrCreatingNew();

  if (!dataIsReceived) {
    return <div />;
  }

  return body();

  function body() {
    return (
      <div className="page-model-info-container">
        <DivColumn style={{ width: "225rem" }}>
          <DivRow className="model-1-frame-1">
            {rightDesignUi()}
            <DivColumn className="model-2-frame" as="form" onSubmit={handleFormSubmit}>
              {modelDesignGeneral()}
            </DivColumn>
          </DivRow>
        </DivColumn>
        {alertDialogs()}
      </div>
    );
  }

  function rightDesignUi() {
    return (
      <DivColumn className="model-7-frame" style={{ minHeight: "90.4rem" }}>
        <WidgetSmallTransportationTitle />
        <WidgetMarginHeight height="1.7rem" />
        <WidgetSearchFrame
          showSearchTerminal={showSearchTerminal}
          handleSearchTerminalIconClick={handleSearchTerminalIconClick}
          uniqueDistricts={uniqueDistricts}
          uniquePlanningSpace={uniquePlanningSpace}
          uniqueMunicipalities={uniqueMunicipalities}
          uniqueTerminals={uniqueTerminals}
          selectedDistrict={selectedDistrict}
          selectedPlanningSpace={selectedPlanningSpace}
          selectedMunicipality={selectedMunicipality}
          selectedTerminal={selectedTerminal}
          handleSelectDropdownDistrict={handleSelectDropdownDistrict}
          handleSelectDropdownPlanningSpace={handleSelectDropdownPlanningSpace}
          handleSelectDropdownMunicipality={handleSelectDropdownMunicipality}
          handleSelectDropdownTerminal={handleSelectDropdownTerminal}
        />
        <WidgetMarginHeight height="0.5rem" />
        <WidgetDashboardIcon />
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetCreateTerminalIcon
              isCreateBlocked={!!selectedModelVersion?.isFrozen}
              onCreateBlocked={() => setIsFrozenTerminalBlockedOpen(true)}
            />
          </>
        )}
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetUsersIcon />
          </>
        )}
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetChangeRequestsIcon />
          </>
        )}
        <WidgetMarginHeight height="1.7rem" />
        <WidgetChangelogFrame showUpdatesList={showUpdatesList} handleShowUpdatesListClick={handleShowUpdatesListClick} updatesListGeneralUi={updatesListGeneralUi} />
      </DivColumn>
    );
  }

  function updatesListGeneralUi() {
    return <WidgetUpdatesListGeneral data={modelChangesLog} />;
  }

  function modelDesignGeneral() {
    return (
      <DivColumn className="model-2-frame">
        <div className="model-2-frame-2">
          <DivColumn className="model-2-frame-3">
            {modelMetricsSection()}
            {modelCostsSection()}
          </DivColumn>
          {modelSettingsPanel()}
        </div>
        {modelCostsDetails()}
      </DivColumn>
    );
  }

  function modelMetricsSection() {
    return (
      <DivColumn className="model-2-frame-4">
        <div className="model-2-frame-5">
          {modelMetricsHeader()}
          {modelMetricsPercentages()}
          {modelMetricsLabels()}
          {modelMetricsGauge1()}
          {modelMetricsGauge2()}
          {modelMetricsGauge3()}
          {modelMetricsGauge4()}
          {modelMetricsGauge5()}
        </div>
      </DivColumn>
    );
  }

  function modelMetricsHeader() {
    return (
      <DivColumn className="model-2-frame-6">
        <DivColumn className="model-2-frame-7">
          <WidgetIconFive iconProp={ConstantsImages.CAR_IMAGE} widthIconProp="2.0rem" heightIconProp="1.5rem" />
          <ParagraphText className="model-text-2" style={{ textAlign: "center" }}>
            {ConstantsTexts.CODE_4}
          </ParagraphText>
        </DivColumn>
        <WidgetProgressPercent progress={getMainMeasurePercent(1)} />
      </DivColumn>
    );
  }

  function modelMetricsPercentages() {
    return (
      <DivColumn className="model-2-frame-9">
        <DivColumn className="model-2-frame-10">
          <WidgetInputPercent value={inputValueUrgencyPercent} onChange={handleChangeUrgencyPercent}  disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputPercent value={inputValueImportanceServicePercent} onChange={handleChangeImportanceServicePercent}  disabled={fieldsReadOnly}/>
        <WidgetInputPercent value={inputValuePotentialPercent} onChange={handleChangePotentialPercent}  disabled={fieldsReadOnly}/>
        <WidgetInputPercent value={inputValueReducingOperationalGapPercent} onChange={handleChangeReducingOperationalGapPercent}  disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelMetricsLabels() {
    return (
      <DivColumn className="model-2-frame-14" style={{ width: "12.5rem" }}>
        <DivColumn className="model-2-frame-15">
          <ModelDesignFrameText title={ConstantsTexts.CODE_17} text={ConstantsTexts.CODE_18} />
        </DivColumn>
        <ModelDesignFrameText title={ConstantsTexts.CODE_19} text={ConstantsTexts.CODE_20} />
        <ModelDesignFrameText title={ConstantsTexts.CODE_21} text={ConstantsTexts.CODE_22} />
        <ModelDesignFrameText title={ConstantsTexts.CODE_23} text={ConstantsTexts.CODE_24} />
      </DivColumn>
    );
  }

  function modelMetricsGauge1() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={1} />
          <WidgetInputSecond
            value={inputValueUrgencyOne}
            onChange={handleChangeUrgencyOne}
            widthProp="18.34rem"
            textAlignProp="right"
            fontFamilyProp="Heebo"
            disabled={fieldsReadOnly}
          />
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueImportanceServiceOneFrom}
          valueToInput={inputValueImportanceServiceOneTo}
          onChangeFromInput={handleChangeImportanceServiceOneFrom}
          onChangeToInput={handleChangeImportanceServiceOneTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialOneFrom)}
          valueToInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialOneTo)}
          onChangeFromInput={handleChangePotentialOneFrom}
          onChangeToInput={handleChangePotentialOneTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={inputValueReducingOperationalGapOneFrom}
          valueToInput={inputValueReducingOperationalGapOneTo}
          onChangeFromInput={handleChangeReducingOperationalGapOneFrom}
          onChangeToInput={handleChangeReducingOperationalGapOneTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelMetricsGauge2() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={2} />
          <WidgetInputSecond
            value={inputValueUrgencyTwo}
            onChange={handleChangeUrgencyTwo}
            widthProp="18.34rem"
            textAlignProp="right"
            fontFamilyProp="Heebo"
            disabled={fieldsReadOnly}
          />
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueImportanceServiceTwoFrom}
          valueToInput={inputValueImportanceServiceTwoTo}
          onChangeFromInput={handleChangeImportanceServiceTwoFrom}
          onChangeToInput={handleChangeImportanceServiceTwoTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialTwoFrom)}
          valueToInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialTwoTo)}
          onChangeFromInput={handleChangePotentialTwoFrom}
          onChangeToInput={handleChangePotentialTwoTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={inputValueReducingOperationalGapTwoFrom}
          valueToInput={inputValueReducingOperationalGapTwoTo}
          onChangeFromInput={handleChangeReducingOperationalGapTwoFrom}
          onChangeToInput={handleChangeReducingOperationalGapTwoTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelMetricsGauge3() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={3} />
          <WidgetInputSecond
            value={inputValueUrgencyThree}
            onChange={handleChangeUrgencyThree}
            widthProp="18.34rem"
            textAlignProp="right"
            fontFamilyProp="Heebo"
            disabled={fieldsReadOnly}
          />
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueImportanceServiceThreeFrom}
          valueToInput={inputValueImportanceServiceThreeTo}
          onChangeFromInput={handleChangeImportanceServiceThreeFrom}
          onChangeToInput={handleChangeImportanceServiceThreeTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialThreeFrom)}
          valueToInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialThreeTo)}
          onChangeFromInput={handleChangePotentialThreeFrom}
          onChangeToInput={handleChangePotentialThreeTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={inputValueReducingOperationalGapThreeFrom}
          valueToInput={inputValueReducingOperationalGapThreeTo}
          onChangeFromInput={handleChangeReducingOperationalGapThreeFrom}
          onChangeToInput={handleChangeReducingOperationalGapThreeTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelMetricsGauge4() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={4} />
          <WidgetInputSecond
            value={inputValueUrgencyFour}
            onChange={handleChangeUrgencyFour}
            widthProp="18.34rem"
            textAlignProp="right"
            fontFamilyProp="Heebo"
            disabled={fieldsReadOnly}
          />
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueImportanceServiceFourFrom}
          valueToInput={inputValueImportanceServiceFourTo}
          onChangeFromInput={handleChangeImportanceServiceFourFrom}
          onChangeToInput={handleChangeImportanceServiceFourTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialFourFrom)}
          valueToInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialFourTo)}
          onChangeFromInput={handleChangePotentialFourFrom}
          onChangeToInput={handleChangePotentialFourTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={inputValueReducingOperationalGapFourFrom}
          valueToInput={inputValueReducingOperationalGapFourTo}
          onChangeFromInput={handleChangeReducingOperationalGapFourFrom}
          onChangeToInput={handleChangeReducingOperationalGapFourTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelMetricsGauge5() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={5} />
          <WidgetInputSecond
            value={inputValueUrgencyFive}
            onChange={handleChangeUrgencyFive}
            widthProp="18.34rem"
            textAlignProp="right"
            fontFamilyProp="Heebo"
            disabled={fieldsReadOnly}
          />
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueImportanceServiceFiveFrom}
          valueToInput={inputValueImportanceServiceFiveTo}
          onChangeFromInput={handleChangeImportanceServiceFiveFrom}
          onChangeToInput={handleChangeImportanceServiceFiveTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialFiveFrom)}
          valueToInput={UtilsUnit.formatNumberWithCommas(inputValuePotentialFiveTo)}
          onChangeFromInput={handleChangePotentialFiveFrom}
          onChangeToInput={handleChangePotentialFiveTo}
         disabled={fieldsReadOnly}/>
        <WidgetInputsFromTo
          valueFromInput={inputValueReducingOperationalGapFiveFrom}
          valueToInput={inputValueReducingOperationalGapFiveTo}
          onChangeFromInput={handleChangeReducingOperationalGapFiveFrom}
          onChangeToInput={handleChangeReducingOperationalGapFiveTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelCostsSection() {
    return (
      <DivColumn className="model-2-frame-4" style={{ height: "23.3rem" }}>
        <div className="model-2-frame-5">
          {modelCostsHeader()}
          {modelCostsPercentages()}
          {modelCostsLabels()}
          {modelCostsGauge1()}
          {modelCostsGauge2()}
          {modelCostsGauge3()}
          {modelCostsGauge4()}
          {modelCostsGauge5()}
        </div>
      </DivColumn>
    );
  }

  function modelCostsHeader() {
    return (
      <DivColumn className="model-2-frame-6" style={{ height: "18.3rem", gap: "0rem" }}>
        <DivColumn className="model-2-frame-7">
          <WidgetIconFive iconProp={ConstantsImages.COINS_IMAGE} widthIconProp="2.7rem" heightIconProp="2.9rem" />
          <ParagraphText className="model-text-2" style={{ textAlign: "center" }}>
            {ConstantsTexts.CODE_5}
          </ParagraphText>
        </DivColumn>
        <WidgetMarginHeight height="0.9rem" />
        <WidgetProgressPercent progress={getMainMeasurePercent(2)} />
      </DivColumn>
    );
  }

  function modelCostsPercentages() {
    return (
      <DivColumn className="model-2-frame-9">
        <DivColumn className="model-2-frame-10">
          <WidgetInputPercent value={inputValueCostPerPassengerPercent} onChange={handleChangeCostPerPassengerPercent}  disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputPercent value={inputValueCostPerTripPercent} onChange={handleChangeCostPerTripPercent}  disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelCostsLabels() {
    return (
      <DivColumn className="model-2-frame-14" style={{ width: "12.5rem" }}>
        <DivColumn className="model-2-frame-15">
          <ModelDesignFrameText title={ConstantsTexts.CODE_25} text="" />
        </DivColumn>
        <ModelDesignFrameText title={ConstantsTexts.CODE_26} text="" />
      </DivColumn>
    );
  }

  function modelCostsGauge1() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={1} />
          <WidgetInputsFromTo
            valueFromInput={inputValueCostPerPassengerOneFrom}
            valueToInput={inputValueCostPerPassengerOneTo}
            onChangeFromInput={handleChangeCostPerPassengerOneFrom}
            onChangeToInput={handleChangeCostPerPassengerOneTo}
           disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueCostPerTripOneFrom}
          valueToInput={inputValueCostPerTripOneTo}
          onChangeFromInput={handleChangeCostPerTripOneFrom}
          onChangeToInput={handleChangeCostPerTripOneTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelCostsGauge2() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={2} />
          <WidgetInputsFromTo
            valueFromInput={inputValueCostPerPassengerTwoFrom}
            valueToInput={inputValueCostPerPassengerTwoTo}
            onChangeFromInput={handleChangeCostPerPassengerTwoFrom}
            onChangeToInput={handleChangeCostPerPassengerTwoTo}
           disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueCostPerTripTwoFrom}
          valueToInput={inputValueCostPerTripTwoTo}
          onChangeFromInput={handleChangeCostPerTripTwoFrom}
          onChangeToInput={handleChangeCostPerTripTwoTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelCostsGauge3() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={3} />
          <WidgetInputsFromTo
            valueFromInput={inputValueCostPerPassengerThreeFrom}
            valueToInput={inputValueCostPerPassengerThreeTo}
            onChangeFromInput={handleChangeCostPerPassengerThreeFrom}
            onChangeToInput={handleChangeCostPerPassengerThreeTo}
           disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueCostPerTripThreeFrom}
          valueToInput={inputValueCostPerTripThreeTo}
          onChangeFromInput={handleChangeCostPerTripThreeFrom}
          onChangeToInput={handleChangeCostPerTripThreeTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelCostsGauge4() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={4} />
          <WidgetInputsFromTo
            valueFromInput={inputValueCostPerPassengerFourFrom}
            valueToInput={inputValueCostPerPassengerFourTo}
            onChangeFromInput={handleChangeCostPerPassengerFourFrom}
            onChangeToInput={handleChangeCostPerPassengerFourTo}
           disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueCostPerTripFourFrom}
          valueToInput={inputValueCostPerTripFourTo}
          onChangeFromInput={handleChangeCostPerTripFourFrom}
          onChangeToInput={handleChangeCostPerTripFourTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelCostsGauge5() {
    return (
      <DivColumn className="model-2-frame-17">
        <DivColumn className="model-2-frame-18">
          <GaugeUI numberText={5} />
          <WidgetInputsFromTo
            valueFromInput={inputValueCostPerPassengerFiveFrom}
            valueToInput={inputValueCostPerPassengerFiveTo}
            onChangeFromInput={handleChangeCostPerPassengerFiveFrom}
            onChangeToInput={handleChangeCostPerPassengerFiveTo}
           disabled={fieldsReadOnly}/>
        </DivColumn>
        <WidgetInputsFromTo
          valueFromInput={inputValueCostPerTripFiveFrom}
          valueToInput={inputValueCostPerTripFiveTo}
          onChangeFromInput={handleChangeCostPerTripFiveFrom}
          onChangeToInput={handleChangeCostPerTripFiveTo}
         disabled={fieldsReadOnly}/>
      </DivColumn>
    );
  }

  function modelSettingsPanel() {
    return (
      <DivColumn className="model-2-frame-27">
        {modelVersionControls()}
        {modelVersionControlsManager()}
        {modelVersionControlsActions()}
        {modelTimeSettings()}
        {modelApplicabilitySettings()}
        {modelMetropolitanSettings()}
      </DivColumn>
    );
  }

  // Renders save/cancel, or frozen-version bar above the model dropdown when frozen
  function modelVersionControls() {
    const showFrozenBar = !!selectedModelVersion?.isFrozen && !isCreatingNewModelVersion;
    if (showFrozenBar) {
      return (
        <DivRow className="model-frozen-version-bar">
          <ParagraphText className="model-frozen-version-bar-text">
            {ConstantsTexts.CODE_249} {ConstantsTexts.CODE_250}
          </ParagraphText>
          <WidgetIconFive iconProp={ConstantsImages.FREEZE_VERSION_IMAGE} widthIconProp="1.3rem" heightIconProp="1.3rem" />
        </DivRow>
      );
    }

    const canEdit = UtilsUnit.managerUser(userData) || (UtilsUnit.editorUserAbove(userData) && selectedModelVersion?.modelVersionInt === 0);

    return (
      <DivRow className="save-n-model-version-frame-1">
        <button type="button" className="model-cancel-version-button" onClick={handleCancelModelChanges}>
          <ParagraphText className="model-cancel-version-text">{ConstantsTexts.CODE_7}</ParagraphText>
          <WidgetIconFive iconProp={ConstantsImages.CLOSE_4_IMAGE} widthIconProp="0.8rem" heightIconProp="0.8rem" />
        </button>
        {canEdit || isCreatingNewModelVersion ? (
          <button type="submit" className="model-save-version-button">
            <ParagraphText className="model-save-version-text">{ConstantsTexts.CODE_34}</ParagraphText>
            <WidgetIconFive iconProp={ConstantsImages.CHECK_WHITE_IMAGE} widthIconProp="1.2rem" heightIconProp="0.8rem" />
          </button>
        ) : (
          <div className="model-save-version-button-spacer" />
        )}
      </DivRow>
    );
  }

  function modelVersionControlsManager() {
    return (
      !isCreatingNewModelVersion && (
        <DivRow className="model-version-dropdown-with-badge">
          <DivColumn className="model-version-dropdown-wrap">
            <WidgetModelVersionDropdown
              widthProp="100%"
              options={modelVersions}
              onSelect={handleSelectModelVersion}
              selectedOptionProp={selectedModelVersion}
              customFooterItemFirst={modelVersionCustomFooterItem()}
              onCustomItemClickFirst={handleCreateModelVersion}
              customFooterItemSecond={modelVersionCustomFooterItemSecond()}
              onCustomItemClickSecond={handleBaseModelChange}
              type={dropdownType}
              enableDelete={UtilsUnit.managerUser(userData)}
              onDelete={handleDeleteModelVersionClick}
            />
          </DivColumn>
        </DivRow>
      )
    );
  }

  function modelVersionControlsActions() {
    const showFreeze = shouldShowFreezeModelVersionButton();
    const showEditor =
      UtilsUnit.managerUser(userData) &&
      !selectedModelVersion?.isFrozen &&
      !isCreatingNewModelVersion;

    if (!showFreeze && !showEditor) {
      return null;
    }

    return (
      <DivRow className="model-version-actions-row">
         {showEditor && (
          <button type="button" className="model-3-frame-9" onClick={() => setDialogUpdateModelFieldsOpen(true)}>
            <ParagraphText className="model-text-11">{ConstantsTexts.CODE_225}</ParagraphText>
            <WidgetIconFive iconProp={ConstantsImages.SETTINGS_IMAGE} widthIconProp="1.5rem" heightIconProp="1.5rem" />
          </button>
        )}
        {showFreeze && (
          <button type="button" className="model-freeze-version-button" onClick={handleFreezeModelVersionClick}>
            <ParagraphText className="model-freeze-version-text">{ConstantsTexts.CODE_240}</ParagraphText>
            <WidgetIconFive iconProp={ConstantsImages.FREEZE_VERSION_IMAGE} widthIconProp="1.3rem" heightIconProp="1.3rem" />
          </button>
        )}
       
      </DivRow>
    );
  }

  // Renders create new model version button only for manager users
  function modelVersionCustomFooterItem() {
    if (!shouldShowCreateModelVersionFooterItem()) {
      return null;
    }
    return <WidgetCustomFooterItemFirst text={ConstantsTexts.CODE_120} />;
  }

  // Renders base model selection button with conditional visibility based on user permissions and available versions
  function modelVersionCustomFooterItemSecond() {
    if (!shouldShowModelVersionCustomFooterItemSecond()) {
      return null;
    }
    return (
      <WidgetCustomFooterItemSecond
        defaultText={ConstantsTexts.CODE_166}
        selectedText={ConstantsTexts.CODE_34}
        isSelected={isBaseModelSelected}
        onCloseClick={handleBaseModelClose}
        onSelectedClick={handleBaseModelChange}
      />
    );
  }

  function modelTimeSettings() {
    return (
      <DivRow className="model-2-frame-30">
        <WidgetInput
          label={ConstantsTexts.CODE_114}
          value={inputValueLifeTime}
          onChange={handleChangeLifeTime}
          heightProp="5rem"
          widthProp="13.9rem"
          backgoundColortProp="#D4D7E5"
          paddingProp="0rem 3rem"
          fontSizeTitle="1.4rem"
         disabled={fieldsReadOnly}/>
        <WidgetInput
          label={ConstantsTexts.CODE_115}
          value={inputValueBusinessDays}
          onChange={handleChangeBusinessDays}
          heightProp="5rem"
          widthProp="13.9rem"
          backgoundColortProp="#D4D7E5"
          paddingProp="0rem 3rem"
          fontSizeTitle="1.4rem"
         disabled={fieldsReadOnly}/>
      </DivRow>
    );
  }

  function modelApplicabilitySettings() {
    return (
      <div className="model-2-frame-31" style={{ height: "13.2rem" }}>
        <DivColumn className="model-2-frame-32">
          <WidgetProgressPercent progress={getMainMeasurePercent(3)} />
          <WidgetInputPercent
            value={inputValuePositionLocalAuthorityPercent}
            onChange={handleChangePositionLocalAuthorityPercent}
            heightProp="4.2rem"
            widthProp="10.55rem"
            paddingRightProp="10.55rem"
            rightPropText="3.45rem"
           disabled={fieldsReadOnly}/>
        </DivColumn>
        <DivColumn className="model-2-frame-33">
          <DivColumn className="model-2-frame-34" style={{ height: "9rem" }}>
            <WidgetIconFive iconProp={ConstantsImages.COINS_IMAGE} widthIconProp="2.7rem" heightIconProp="2.9rem" />
            <ParagraphText className="model-text-2">{ConstantsTexts.CODE_8}</ParagraphText>
          </DivColumn>
          <ParagraphText className="model-text-8">{ConstantsTexts.CODE_9}</ParagraphText>
        </DivColumn>
      </div>
    );
  }

  function modelMetropolitanSettings() {
    return (
      <DivColumn className="model-2-frame-35" style={{ height: UtilsUnit.managerUser(userData) ? "20.8rem" : "24.5rem" }}>
        <ParagraphText className="model-text-9">{ConstantsTexts.CODE_10}</ParagraphText>
        <DivColumn className="model-2-frame-36">
          <div className="model-2-frame-37">
            <WidgetInput
              label={ConstantsTexts.CODE_105}
              value={inputValueMetropolitanRingOne}
              onChange={handleChangeMetropolitanRingOne}
              widthProp="11.7rem"
              fontSizeTitle="1.4rem"
              paddingProp="0rem 2rem"
             disabled={fieldsReadOnly}/>
            <WidgetInput
              label={ConstantsTexts.CODE_106}
              value={inputValueMetropolitanRingTwo}
              onChange={handleChangeMetropolitanRingTwo}
              widthProp="11.7rem"
              fontSizeTitle="1.4rem"
              paddingProp="0rem 2rem"
             disabled={fieldsReadOnly}/>
          </div>
          <div className="model-2-frame-37">
            <WidgetInput
              label={ConstantsTexts.CODE_107}
              value={inputValueMetropolitanRingThree}
              onChange={handleChangeMetropolitanRingThree}
              widthProp="11.7rem"
              fontSizeTitle="1.4rem"
              paddingProp="0rem 2rem"
             disabled={fieldsReadOnly}/>
            <WidgetInput
              label={ConstantsTexts.CODE_108}
              value={inputValueMetropolitanRingFour}
              onChange={handleChangeMetropolitanRingFour}
              widthProp="11.7rem"
              fontSizeTitle="1.4rem"
              paddingProp="0rem 2rem"
             disabled={fieldsReadOnly}/>
          </div>
        </DivColumn>
      </DivColumn>
    );
  }

  function modelCostsDetails() {
    return (
      <div className="model-3-frame">
        {modelCostsDetails1()}
        {modelCostsDetails2()}
        {modelCostsDetails3()}
      </div>
    );
  }

  function modelCostsDetails1() {
    return (
      <>
        <DivColumn className="model-3-frame-2">
          <DivColumn className="model-3-frame-3">
            <ParagraphText className="model-text-10">{ConstantsTexts.CODE_11}</ParagraphText>
            <WidgetInput
              label={ConstantsTexts.CODE_116}
              value={UtilsUnit.formatNumberWithCommas(inputValueCostPerAcre)}
              onChange={handleChangeCostPerAcre}
              heightProp="5.1rem"
              widthProp="54.6rem"
              paddingProp="0rem 2rem"
              backgoundColortProp="#FFF"
             disabled={fieldsReadOnly}/>
          </DivColumn>
          <DivColumn className="model-3-frame-5">
            <DivColumn className="model-3-frame-6">
              <ParagraphText className="model-text-9">{ConstantsTexts.CODE_12}</ParagraphText>
              <div className="model-3-frame-7">
                <WidgetInput label={workMonthsText} value={inputValueMonthsOfWorkOne} onChange={handleChangeMonthsOfWorkOne} widthProp="25.8rem"  disabled={fieldsReadOnly}/>
                <WidgetInput
                  label={buildingCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfBuildingsOne)}
                  onChange={handleChangeCostOfBuildingsOne}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
              </div>
              <div className="model-3-frame-7">
                <WidgetInput
                  label={monthlyTrafficArrangementCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfTrafficOne)}
                  onChange={handleChangeCostOfTrafficOne}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
                <WidgetTextViewData
                  title={totalTrafficArrangementCostText}
                  text={UtilsUnit.formatNumberWithCommaWithShekel(getTotalPriceForTrafficArrangementsPerTerminalTypeNIS(1))}
                  widthProp="25.8rem"
                />
              </div>
            </DivColumn>
          </DivColumn>
        </DivColumn>
      </>
    );
  }

  function modelCostsDetails2() {
    return (
      <>
        <DivColumn className="model-3-frame-8">
          <DivColumn className="model-3-frame-5">
            <DivColumn className="model-3-frame-6">
              <ParagraphText className="model-text-9">{ConstantsTexts.CODE_13}</ParagraphText>
              <div className="model-3-frame-7">
                <WidgetInput label={workMonthsText} value={inputValueMonthsOfWorkTwo} onChange={handleChangeMonthsOfWorkTwo} widthProp="25.8rem"  disabled={fieldsReadOnly}/>
                <WidgetInput
                  label={buildingCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfBuildingsTwo)}
                  onChange={handleChangeCostOfBuildingsTwo}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
              </div>
              <div className="model-3-frame-7">
                <WidgetInput
                  label={monthlyTrafficArrangementCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfTrafficTwo)}
                  onChange={handleChangeCostOfTrafficTwo}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
                <WidgetTextViewData
                  title={totalTrafficArrangementCostText}
                  text={UtilsUnit.formatNumberWithCommaWithShekel(getTotalPriceForTrafficArrangementsPerTerminalTypeNIS(2))}
                  widthProp="25.8rem"
                />
              </div>
            </DivColumn>
          </DivColumn>
          <DivColumn className="model-3-frame-5">
            <DivColumn className="model-3-frame-6">
              <ParagraphText className="model-text-9">{ConstantsTexts.CODE_14}</ParagraphText>
              <div className="model-3-frame-7">
                <WidgetInput label={workMonthsText} value={inputValueMonthsOfWorkThree} onChange={handleChangeMonthsOfWorkThree} widthProp="25.8rem"  disabled={fieldsReadOnly}/>
                <WidgetInput
                  label={buildingCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfBuildingsThree)}
                  onChange={handleChangeCostOfBuildingsThree}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
              </div>
              <div className="model-3-frame-7">
                <WidgetInput
                  label={monthlyTrafficArrangementCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfTrafficThree)}
                  onChange={handleChangeCostOfTrafficThree}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
                <WidgetTextViewData
                  title={totalTrafficArrangementCostText}
                  text={UtilsUnit.formatNumberWithCommaWithShekel(getTotalPriceForTrafficArrangementsPerTerminalTypeNIS(3))}
                  widthProp="25.8rem"
                />
              </div>
            </DivColumn>
          </DivColumn>
        </DivColumn>
      </>
    );
  }

  function modelCostsDetails3() {
    return (
      <>
        <DivColumn className="model-3-frame-8">
          <DivColumn className="model-3-frame-5">
            <DivColumn className="model-3-frame-6">
              <ParagraphText className="model-text-9">{ConstantsTexts.CODE_15}</ParagraphText>
              <div className="model-3-frame-7">
                <WidgetInput label={workMonthsText} value={inputValueMonthsOfWorkFour} onChange={handleChangeMonthsOfWorkFour} widthProp="25.8rem"  disabled={fieldsReadOnly}/>
                <WidgetInput
                  label={buildingCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfBuildingsFour)}
                  onChange={handleChangeCostOfBuildingsFour}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
              </div>
              <div className="model-3-frame-7">
                <WidgetInput
                  label={monthlyTrafficArrangementCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfTrafficFour)}
                  onChange={handleChangeCostOfTrafficFour}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
                <WidgetTextViewData
                  title={totalTrafficArrangementCostText}
                  text={UtilsUnit.formatNumberWithCommaWithShekel(getTotalPriceForTrafficArrangementsPerTerminalTypeNIS(4))}
                  widthProp="25.8rem"
                />
              </div>
            </DivColumn>
          </DivColumn>
          <DivColumn className="model-3-frame-5">
            <DivColumn className="model-3-frame-6">
              <ParagraphText className="model-text-9">{ConstantsTexts.CODE_16}</ParagraphText>
              <div className="model-3-frame-7">
                <WidgetInput label={workMonthsText} value={inputValueMonthsOfWorkFive} onChange={handleChangeMonthsOfWorkFive} widthProp="25.8rem"  disabled={fieldsReadOnly}/>
                <WidgetInput
                  label={buildingCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfBuildingsFive)}
                  onChange={handleChangeCostOfBuildingsFive}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
              </div>
              <div className="model-3-frame-7">
                <WidgetInput
                  label={monthlyTrafficArrangementCostText}
                  value={UtilsUnit.formatNumberWithCommas(inputValueCostOfTrafficFive)}
                  onChange={handleChangeCostOfTrafficFive}
                  widthProp="25.8rem"
                 disabled={fieldsReadOnly}/>
                <WidgetTextViewData
                  title={totalTrafficArrangementCostText}
                  text={UtilsUnit.formatNumberWithCommaWithShekel(getTotalPriceForTrafficArrangementsPerTerminalTypeNIS(5))}
                  widthProp="25.8rem"
                />
              </div>
            </DivColumn>
          </DivColumn>
        </DivColumn>
      </>
    );
  }

  // Renders model design frame text with optional subtitle text
  function ModelDesignFrameText({ title, text }) {
    return (
      <DivColumn className="model-2-frame-16">
        <ParagraphText className="model-text-4">{title}</ParagraphText>
        {text === "" ? <></> : <ParagraphText className="model-text-5">{text}</ParagraphText>}
      </DivColumn>
    );
  }

  function GaugeUI({ numberText }) {
    return <WidgetGaugeUI numberText={numberText} />;
  }

  function alertDialogs() {
    return (
      <>
        {isDialogEditOpen && lastActionRef?.current === ConstantsParams.ActionTypes.FREEZE_VERSION && (
          <WidgetAlertDialogFreezeVersion
            modelVersionInt={modelVersionToFreezeRef.current?.modelVersionInt}
            onApprove={() => closeEditAlertDialog(true)}
            onCancel={() => closeEditAlertDialog(false)}
          />
        )}
        {isDialogEditOpen && lastActionRef?.current !== ConstantsParams.ActionTypes.FREEZE_VERSION && (
          <WidgetAlertDialogEdit
            onApprove={() => closeEditAlertDialog(true)}
            onCancel={() => closeEditAlertDialog(false)}
            messageText={getDialogEditMessageText()}
            approveText={getDialogEditApproveText()}
            cancelText={getDialogEditCancelText()}
            actionType={lastActionRef?.current}
          />
        )}
        {isDialogSaveOpen && lastActionRef?.current === ConstantsParams.ActionTypes.FREEZE_VERSION && (
          <WidgetAlertDialogFreezeSuccess onCancel={closeSaveAlertDialog} messageText={getDialogSaveMessageText()} />
        )}
        {isDialogSaveOpen && lastActionRef?.current !== ConstantsParams.ActionTypes.FREEZE_VERSION && (
          <WidgetAlertDialogSave onCancel={closeSaveAlertDialog} messageText={getDialogSaveMessageText()} />
        )}
        {isDialogUpdateModelFieldsOpen && <WidgetAlertDialogUpdateModelFields onClose={handleCloseUpdateModelFieldsDialog} />}
        {isFrozenTerminalBlockedOpen && (
          <WidgetAlertDialogFrozenTerminalBlocked onClose={() => setIsFrozenTerminalBlockedOpen(false)} />
        )}
      </>
    );
  }
}

export default PageModelInfo;
